import CodexLinkButton from './CodexLinkButton'
import ObjectiveWhyToggle from './ObjectiveWhyToggle'
import './DiagnosticHero.css'

function PriorityTitle({ priority }) {
  const point = priority.point
  const isDegree = point?.isDegree || point?.type === 'degree'
  if (isDegree && point?.type !== 'pattern') {
    return (
      <>
        <span className="degree-roman">{priority.title}</span>
        {priority.meta ? (
          <span className="diagnostic-priority-meta"> · {priority.meta}</span>
        ) : null}
      </>
    )
  }
  return (
    <>
      {priority.title}
      {priority.meta ? (
        <span className="diagnostic-priority-meta"> · {priority.meta}</span>
      ) : null}
    </>
  )
}

function DiagnosticPriorityItem({ priority, onWorkPriority, onOpenCodex }) {
  const detailId = `diagnostic-why-${priority.rank}-${priority.point?.type}-${priority.point?.value}`

  return (
    <li
      className={`diagnostic-priority-item${priority.rank === 1 ? ' diagnostic-priority-item--primary' : ''}`}
    >
      <div className="diagnostic-priority-header">
        <span className="diagnostic-priority-rank" aria-hidden="true">
          {priority.rank}
        </span>
        <div className="diagnostic-priority-body">
          {priority.detailWhy ? (
            <ObjectiveWhyToggle
              id={detailId}
              detail={priority.detailWhy}
              ariaLabel="Pourquoi cette priorité ?"
            >
              <p className="diagnostic-priority-title">
                <PriorityTitle priority={priority} />
              </p>
            </ObjectiveWhyToggle>
          ) : (
            <p className="diagnostic-priority-title">
              <PriorityTitle priority={priority} />
            </p>
          )}
          {priority.subtitle ? (
            <p className="diagnostic-priority-subtitle">{priority.subtitle}</p>
          ) : null}
        </div>
      </div>
      <div className="diagnostic-priority-actions">
        {onWorkPriority ? (
          <button
            type="button"
            className={
              priority.rank === 1
                ? 'diagnostic-hero-cta-primary diagnostic-priority-cta'
                : 'diagnostic-hero-cta-secondary diagnostic-priority-cta'
            }
            onClick={() => onWorkPriority(priority.point)}
          >
            {priority.ctaLabel}
          </button>
        ) : null}
        {priority.codex?.ficheId && onOpenCodex ? (
          <CodexLinkButton
            compact
            ariaLabel={`Ouvrir la fiche Codex : ${priority.title}`}
            onClick={() =>
              onOpenCodex(priority.codex.ficheId, priority.codex.sectionId || null)
            }
          />
        ) : null}
      </div>
    </li>
  )
}

/**
 * Hero bilan : priorités actionnables (1–3) ou message simple + CTA.
 */
function DiagnosticHero({
  variant = 'simple',
  sectionTitle,
  priorities = [],
  headline,
  detail,
  primaryCta,
  secondaryCta,
  onPrimary,
  onSecondary,
  onWorkPriority,
  onOpenCodex
}) {
  if (variant === 'priorities' && priorities.length > 0) {
    return (
      <div className="diagnostic-hero">
        <p className="diagnostic-hero-eyebrow">Ton bilan</p>
        {sectionTitle ? (
          <h3 className="diagnostic-hero-section-title">{sectionTitle}</h3>
        ) : null}
        <ol className="diagnostic-priority-list">
          {priorities.map((priority) => (
            <DiagnosticPriorityItem
              key={`${priority.point?.type}-${priority.point?.value}-${priority.rank}`}
              priority={priority}
              onWorkPriority={onWorkPriority}
              onOpenCodex={onOpenCodex}
            />
          ))}
        </ol>
        {secondaryCta && onSecondary ? (
          <div className="diagnostic-hero-footer">
            <button type="button" className="diagnostic-hero-cta-secondary" onClick={onSecondary}>
              {secondaryCta}
            </button>
          </div>
        ) : null}
      </div>
    )
  }

  return (
    <div className="diagnostic-hero">
      <p className="diagnostic-hero-eyebrow">Ton bilan</p>
      <h3 className="diagnostic-hero-headline">{headline}</h3>
      {detail ? <p className="diagnostic-hero-detail">{detail}</p> : null}
      <div className="diagnostic-hero-actions">
        {primaryCta && onPrimary ? (
          <button type="button" className="diagnostic-hero-cta-primary" onClick={onPrimary}>
            {primaryCta}
          </button>
        ) : null}
        {secondaryCta && onSecondary ? (
          <button type="button" className="diagnostic-hero-cta-secondary" onClick={onSecondary}>
            {secondaryCta}
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default DiagnosticHero
